import React from 'react';
import { observer } from 'mobx-react-lite';
import { CheckIcon } from '@radix-ui/react-icons';
import { CircleCancel, CrownBadge, IconButton } from '@producer/ui-kit';
import { CoverImage } from '../../../components/cover-image/cover-image';
import { Tooltip } from '../../../components/tooltip/Tooltip';
import { DeleteDialog } from '../../../components/dialogs/DeleteDialog';
import { openModal } from '../../../core/modal/open-modal';
import { Contact } from '../../../app/entities';

import type { Candidate } from '../../../app/entities/candidate';

import styles from './candidate-card.module.scss';
type CandidateCardProps = {
  candidate: Candidate;
  isSelectedCandidate?: boolean;
};

export const CandidateCard: React.FC<CandidateCardProps> = observer(
  ({ candidate, isSelectedCandidate }) => {
    const handleApprove = async () => {
      if (isSelectedCandidate) {
        await candidate.character.update({ cast: null });
        return;
      }

      await candidate.character.assignCast(candidate._id);
    };

    const handleOnRemove = async () => {
      await candidate.character.removeCandidate(candidate._id);
    };

    const openRemoveCandidateModal = () => {
      openModal(DeleteDialog, {
        onSubmit: handleOnRemove,
        title: 'Are you sure you want to remove candidate?',
        text: 'Candidate will be removed immediately. After removing you can add candidate from candidates list',
      });
    };

    const contact = Contact.getOne(candidate.contactId);

    return (
      <div className={styles['card']} data-active={isSelectedCandidate}>
        <div className={styles['candidate-image-container']}>
          <CoverImage src={candidate.avatar || contact?.avatar || ''} title={candidate.fullName} />
        </div>

        <div className={styles['info-container']}>
          <h6 className={styles['candidate-name']}>{candidate.fullName}</h6>

          <p className={styles['candidate-title']}>Actor</p>
        </div>

        <div className={styles['right-container']}>
          {isSelectedCandidate && <CrownBadge />}

          <div className={styles['buttons-container']}>
            <div className={styles['select-button-container']} data-active={isSelectedCandidate}>
              <Tooltip text="Select Candidate" position="top" disabled={isSelectedCandidate}>
                <IconButton icon={<CheckIcon />} onClick={handleApprove} />
              </Tooltip>
            </div>

            <div className={styles['remove-button-container']}>
              <Tooltip text="Remove Candidate" position="top">
                <IconButton icon={<CircleCancel />} onClick={openRemoveCandidateModal} />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  },
);
